import axios from "axios";
import api from "../server/api";

const GET_SHIPPING_TRACKING_REQUEST = "TYP/GET_SHIPPING_TRACKING_REQUEST";
const GET_SHIPPING_TRACKING_SUCCESS = "TYP/GET_SHIPPING_TRACKING_SUCCESS";
const GET_SHIPPING_TRACKING_FAILURE = "TYP/GET_SHIPPING_TRACKING_FAILURE";

const GET_SHIPPING_LOGO_REQUEST = "TYP/GET_SHIPPING_LOGO_REQUEST";
const GET_SHIPPING_LOGO_SUCCESS = "TYP/GET_SHIPPING_LOGO_SUCCESS";
const GET_SHIPPING_LOGO_FAILURE = "TYP/GET_SHIPPING_LOGO_FAILURE";

const GET_SHIPPING_BY_ID_REQUEST = "TYP/GET_SHIPPING_BY_ID_REQUEST";
const GET_SHIPPING_BY_ID_SUCCESS = "TYP/GET_SHIPPING_BY_ID_SUCCESS";
const GET_SHIPPING_BY_ID_FAILURE = "TYP/GET_SHIPPING_BY_ID_FAILURE";

const initialState = {
  loading: false,
  error: false,
  data: null,
  shippingData: [],
  shippingLogo: null,
};

export default function reducerShippings(state = initialState, action) {
  switch (action.type) {
    case GET_SHIPPING_TRACKING_REQUEST:
      return { ...state, loading: true, error: false };
    case GET_SHIPPING_TRACKING_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case GET_SHIPPING_TRACKING_FAILURE:
      return {
        ...state,
        loading: false,
        shippingLogo: null,
        error: action.payload,
      };
    case GET_SHIPPING_LOGO_REQUEST:
      return { ...state, loading: true, error: false };
    case GET_SHIPPING_LOGO_SUCCESS:
      return {
        ...state,
        loading: false,
        shippingLogo: action.payload,
      };
    case GET_SHIPPING_LOGO_FAILURE:
      return {
        ...state,
        loading: false,
        shippingLogo: null,
        error: action.payload,
      };
    case GET_SHIPPING_BY_ID_REQUEST:
      return { ...state, loading: true, error: false };
    case GET_SHIPPING_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        shippingData: action.payload,
      };
    case GET_SHIPPING_BY_ID_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };

    default:
      return state;
  }
}

export const getTrackingData = (id, key, language) => {
  return async (dispatch) => {
    dispatch({
      type: GET_SHIPPING_TRACKING_REQUEST,
    });
    try {
      const { url, method, headers, params } = api.getTrackingData(
        id,
        key,
        language
      );
      const shippingData = await axios({
        url,
        method,
        headers,
        params,
      });
      dispatch({
        type: GET_SHIPPING_TRACKING_SUCCESS,
        payload: shippingData.data,
      });
    } catch (error) {
      console.log("error", error);
      console.log("error", error.response);
      dispatch({
        type: GET_SHIPPING_TRACKING_FAILURE,
        payload: error,
      });
    }
  };
};

export const getTrackingDataWithCode = (reference, language) => {
  console.log("refence", reference);
  return async (dispatch) => {
    dispatch({
      type: GET_SHIPPING_TRACKING_REQUEST,
    });
    try {
      const { url, method, headers, params } = api.getTrackingDataWithCode(
        reference,
        language
      );
      console.log("url", url);
      const shippingData = await axios({
        url,
        method,
        headers,
        params,
      });
      localStorage.setItem("id", shippingData.data.shipmentId);
      dispatch({
        type: GET_SHIPPING_TRACKING_SUCCESS,
        payload: shippingData.data,
      });
    } catch (error) {
      console.log("error", error);
      console.log("error response", error.response);
      dispatch({
        type: GET_SHIPPING_TRACKING_FAILURE,
        payload: error,
      });
    }
  };
};

export const getTrackingDataWithCustomerCode = (
  customerCode,
  customerReference,
  language
) => {
  return async (dispatch) => {
    dispatch({
      type: GET_SHIPPING_TRACKING_REQUEST,
    });
    try {
      const { url, method, headers, params } =
        api.getTrackingDataWithCustomerCode(
          customerCode,
          customerReference,
          language
        );

      const shippingData = await axios({
        url,
        method,
        headers,
        params,
      });
      localStorage.setItem("id", shippingData.data.shipmentId);
      dispatch({
        type: GET_SHIPPING_TRACKING_SUCCESS,
        payload: shippingData.data,
      });
    } catch (error) {
      console.log("error", error);
      console.log("error response", error.response);
      dispatch({
        type: GET_SHIPPING_TRACKING_FAILURE,
        payload: error,
      });
    }
  };
};

export const getShippingLogo = (contractId) => {
  return async (dispatch) => {
    dispatch({
      type: GET_SHIPPING_LOGO_REQUEST,
    });
    try {
      const { url, method, headers } = api.getShippingLogo(contractId);
      const shippingLogo = await axios({
        url,
        method,
        headers,
      });
      dispatch({
        type: GET_SHIPPING_LOGO_SUCCESS,
        payload: shippingLogo.data,
      });
    } catch (error) {
      console.log("error", error);
      console.log("error", error.response);
      dispatch({
        type: GET_SHIPPING_LOGO_FAILURE,
        payload: error,
      });
    }
  };
};

export const getShippingById = (id, key) => {
  return async (dispatch) => {
    dispatch({
      type: GET_SHIPPING_BY_ID_REQUEST,
    });
    try {
      const { url, method, headers, params, data } = api.getShippingById(
        id,
        key
      );
      const shippingData = await axios({
        url,
        method,
        headers,
        params,
        data,
      });

      dispatch({
        type: GET_SHIPPING_BY_ID_SUCCESS,
        payload: shippingData.data,
      });
    } catch (error) {
      console.log("error", error);
      console.log("error", error.response);
      dispatch({
        type: GET_SHIPPING_BY_ID_FAILURE,
        payload: error,
      });
    }
  };
};
